<template>
  <div class="card is-height-70p">
    <gmap-map
      :center="centerDefault"
      :zoom="zoomDefault"
      :options="{
        mapTypeControlOptions: mapType,
      }"
      class="googleMap"
      id="mapGroupe"
      ref="mapCartoGeneralGroupe"
      @zoom_changed="getZoom = $event">

      <!-- Marker point de vente -->
      <gmap-marker
        v-for="(markerPdv, i) in filtrePdvs"
        :key="'pdv'+i"
        :position="markerPdv.adresse.coordonnees"
        :icon="markerPdv.icon"
        @click="accessRecom(markerPdv.previewLink)">
      </gmap-marker>

      <gmap-cluster :minimumClusterSize="7">
        <!-- Marker panneau -->
        <gmap-marker
          v-for="(markerPan, i) in filtrePanneaux"
          :key="'pan'+i"
          :position="markerPan.adresse.coordonnees"
          :icon="getIconPanneau(markerPan)">
        </gmap-marker>
      </gmap-cluster>
      
    </gmap-map>
  </div>
</template>

<script>
import { COULEUR_PANNEAU_SOUS_CONTRAT } from '@/configurations/configPanneau';
import { CENTER_DEFAULT, ZOOM_DEFAULT,
  MAP_TYPE_CONTROL_OPTIONS,
  STYLE_MAPS_POI_HIDDEN, MAP_TYPE_NAME,
} from '@/configurations/configurationCarto';
import { getIconPanneau } from '@/services/gestionIconMarker/iconColorGetter';

export default {
  props: {
    pointDeVentes: Array,
    panneaux: Array
  },
  data() {
    return {
      isLoadOnce: false,
      centerDefault: CENTER_DEFAULT,
      zoomDefault: ZOOM_DEFAULT,
      getZoom: 0,
      isLoading: false,
      mapType: MAP_TYPE_CONTROL_OPTIONS,
      func: { getIconPanneau }
    };
  },
  watch: {
    async filtrePdvs(val) {
      if (!val.length) return;
      await this.levelZoom();
    },
    async filtrePanneaux(val) {
      if (!val.length) return;
      await this.levelZoom();
    },
  },
  computed: {
    filtrePdvs() {
      if (!this.pointDeVentes.length) return [];
      if (this.$route.name === 'ListePointDeVente') {
        return this.pointDeVentes.filter(pdv => pdv.idEnseigne === this.$route.params.id);
      }
      return this.pointDeVentes;
    },
    filtrePanneaux() {
      if (!this.panneaux.length) return [];
      if (this.$route.name === 'ListePointDeVente') {
        return this.panneaux.filter(pdv => pdv.idEnseigne === this.$route.params.id);
      }
      return this.panneaux;
    }
  },
  methods: {
    getIconPanneau(panneau) {
      const couleur = panneau.estPanneauSousContrat
        ? COULEUR_PANNEAU_SOUS_CONTRAT
        : panneau.categorie?.couleur;
      return getIconPanneau({ ...panneau, categorie: { couleur } });
    },
    async initPoi() {
      const map = await this.$refs.mapCartoGeneralGroupe.$mapPromise;
      const styleMap = new google.maps.StyledMapType(
        STYLE_MAPS_POI_HIDDEN,
        { name: MAP_TYPE_NAME },
      );
      map.mapTypes.set('styled_map', styleMap);
    },
    async levelZoom() {
      if (!this.$refs.mapCartoGeneralGroupe.$mapPromise) return;
      await this.$refs.mapCartoGeneralGroupe.$mapPromise;
      this.fitBounds();
    },
    fitBounds() {
      const bounds = new google.maps.LatLngBounds();
      const coordonneesList = [
        ...this.filtrePdvs.map((el) => el.adresse.coordonnees),
        ...this.filtrePanneaux.map((el) => el.adresse.coordonnees),
      ].filter(Boolean);
      coordonneesList.forEach(el => {
        bounds.extend(el);
      });
      this.$refs.mapCartoGeneralGroupe.fitBounds(bounds);
    },
    accessRecom(lien){
      window.open(lien);
    },
  },
  async mounted() {
    await this.initPoi();
    await this.levelZoom();
  },
};
</script>
